import { Component, HostListener, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ConductorDTO } from '../../../dtos/conductor.dto';
import { ConductorService } from '../../services/conductor.service';
import { SucursalService } from '../../services/sucursal.service';
import { ApiService } from '../../services/api.service';
import { SucursalDTO } from '../../../dtos/sucursal.dto';
import { GetListaSucursalesResponseDTO } from '../../../dtos/response/getListaSucursales.response.dto';
import { HttpErrorResponse } from '@angular/common/http';
import { AppMessage } from '../../app.message';
import { ToastrService } from 'ngx-toastr';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { EventService } from '../../services/event.service';
import { GeneralResponseDTO } from '../../../dtos/response/general.response.dto';
import { NgIf } from '@angular/common';
import { UserService } from '../../services/user.service';

@Component({
  selector: 'app-modal-cambiar-sucursal-cb',
  standalone: true,
  imports: [NgSelectModule, FormsModule, NgIf],
  templateUrl: './modal-cambiar-sucursal-cb.component.html',
  styleUrl: './modal-cambiar-sucursal-cb.component.scss'
})
export class ModalCambiarSucursalCbComponent implements OnInit {

  private conductor: ConductorDTO;
  public listaSucursales: Array<SucursalDTO> = [];
  public sucursalSeleccionada: SucursalDTO;
  public listadoSucursalesDisponibles: Array<SucursalDTO> = [];

  constructor(
    private modalRef: BsModalRef,
    private conductorService: ConductorService,
    private apiService: ApiService,
    private sucursalService: SucursalService,
    private eventService: EventService,
    private toastr: ToastrService,
    private userService: UserService,
  ) { }

  ngOnInit(): void {
    this.conductor = this.conductorService.getConductorSeleccionado();
    // this.listadoSucursalesDisponibles =  this.sucursalService.getSucursalesSeleccionadas();
    this.getListaSucursales();
  }

  @HostListener('document:keydown.escape', ['$event'])
  onEscape(event: KeyboardEvent) {
    this.close();
  }

  getListaSucursales() {
    this.apiService.getListaSucursales().subscribe(
      (resp) => this.getListaSucursalesSuccess(resp),
      (error) => this.getListaSucursalesError(error)
    );
  }

  getListaSucursalesSuccess(getListaSucursalesResponseDTO: GetListaSucursalesResponseDTO) {
    console.log('exito get sucursales', getListaSucursalesResponseDTO);
    this.listaSucursales = getListaSucursalesResponseDTO.data;
  }

  getListaSucursalesError(error: HttpErrorResponse) {
    console.log('error get sucursales', error);
    const msg = error.error.msg ? error.error.msg : AppMessage.ERROR_PUT_CAMBIAR_SUCURSAL_CONDUCTORES_WS;
    this.toastr.error(msg + (error['requestId'] ? ' Code: ' + error['requestId'] : ''), 'Error', { timeOut: environment.toastErrorTimeout, extendedTimeOut: environment.toastErrorTimeout, closeButton: true, tapToDismiss: false });
  }

  cambiarSucursal() {
    if (!this.sucursalSeleccionada) {
      this.toastr.warning("Debe seleccionar una sucursal", 'Aviso', { timeOut: environment.toastWarningTimeout, extendedTimeOut: environment.toastWarningTimeout, closeButton: true, tapToDismiss: false });
      return;
    }
    this.apiService.putActualizarSucursalConductor(this.conductor.uuid, this.sucursalSeleccionada.uuid)
      .subscribe(res => this.putActualizarSucursalConductoresSuccess(res), error => this.putActualizarSucursalConductorError(error));
  }

  putActualizarSucursalConductoresSuccess(generalResponseDTO: GeneralResponseDTO) {
    console.log('put sucursal joranda success', generalResponseDTO);
    this.eventService.publish('CAMBIAR_SUCURSAL_CONDUCTORES_EVENT');
    this.close();
  }

  putActualizarSucursalConductorError(error: HttpErrorResponse) {
    console.log('put sucursal jornada error', error);
    const msg = error.error && error.error.msg ? error.error.msg : AppMessage.ERROR_PUT_CAMBIAR_SUCURSAL_CONDUCTORES_WS;
    //alert(msg);
    this.toastr.error(msg + (error['requestId'] ? ' Code: ' + error['requestId'] : ''), 'Error', { timeOut: environment.toastErrorTimeout, extendedTimeOut: environment.toastErrorTimeout, closeButton: true, tapToDismiss: false });
  }

  close() {
    this.modalRef.hide();
  }

  tienePermisoCambiarSucursal(): boolean {
    return this.userService.tienePermiso('CONDUCTOR_CAMBIAR_SUCURSAL');
  }

  get getConductor(): ConductorDTO {
    return this.conductor;
  }

}
